document.addEventListener('DOMContentLoaded', () => {
  async function addVariantInfo(card) {
    if (!card) return;

    if (
      card.dataset.variantInfoLoaded === 'true' ||
      card.dataset.variantInfoLoaded === 'loading'
    ) {
      return;
    }

    card.dataset.variantInfoLoaded = 'loading';

    try {
      const productLink = card.querySelector('a[href*="/products/"]');

      if (!productLink) {
        card.dataset.variantInfoLoaded = 'false';
        return;
      }

      const productUrl = new URL(productLink.href, window.location.origin);

      const response = await fetch(`${productUrl.pathname}.js`);

      if (!response.ok) {
        throw new Error(`Produktdaten konnten nicht geladen werden: ${response.status}`);
      }

      const product = await response.json();

      if (!product || !Array.isArray(product.variants)) {
        card.dataset.variantInfoLoaded = 'false';
        return;
      }

      const availableVariants = product.variants
        .filter((variant) => variant.available)
        .map((variant) => {
          if (variant.title && variant.title !== 'Default Title') {
            return variant.title;
          }

          return '';
        })
        .filter(Boolean);

      if (!availableVariants.length) {
        card.dataset.variantInfoLoaded = 'true';
        return;
      }

      const uniqueVariants = [...new Set(availableVariants)];

      const titleElement =
        card.querySelector('.rps-product-title') ||
        card.querySelector('[class*="rps-product-title"]') ||
        card.querySelector('a[href*="/products/"]');

      if (!titleElement) {
        card.dataset.variantInfoLoaded = 'false';
        return;
      }

      card.querySelectorAll('.dp-variant-info').forEach((element) => {
        element.remove();
      });

      const info = document.createElement('div');
      info.className = 'dp-variant-info';
      info.textContent = `Verfügbar: ${uniqueVariants.join(', ')}`;

      titleElement.insertAdjacentElement('afterend', info);

      card.dataset.variantInfoLoaded = 'true';
    } catch (error) {
      console.warn('Don Pallone Variant Info:', error);
      card.dataset.variantInfoLoaded = 'false';
    }
  }

  function scanCards() {
    document
      .querySelectorAll('.rps-product-container')
      .forEach((card) => {
        addVariantInfo(card);
      });
  }

  scanCards();

  const observer = new MutationObserver(() => {
    scanCards();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});